import { ComponentClass } from 'react'
import { ResultProps } from '../../../../utils/ResultViewer/ResultViewer'
import Table from '../../../../utils/ResultViewer/Table'

type CompanySitesProps = ResultProps & {
  location?: any
  /** When set, only these site IDs are editable (site-scoped users). */
  editableSiteIds?: number[] | null
}

class CompanySitesTable extends Table {
  //@ts-ignore
  public state: CompanySitesProps
  constructor(props: CompanySitesProps) {
    super(props)
    this.state = {
      title: props.title,
      actionItems: props.actionItems,
      dataUrl: props.dataUrl,
      data: {
        headers: {},
        data: [],
        search: [],
        pagination: {
          limit: 100,
          page: 1,
          total_count: 0,
        },
      },
      page: 1,
      orderBy: '',
      orderDirection: '',
      editCallback: props.editCallback,
      deleteCallback: props.deleteCallback,
      filterParams: {},
      location: props.location,
      canEdit: props.canEdit ?? true,
      canDelete: props.canDelete ?? true,
      editableSiteIds: props.editableSiteIds ?? null,
    }
  }

  isRowEditable(siteId: number): boolean {
    if (!this.state.canEdit) {
      return false
    }
    if (this.state.editableSiteIds == null) {
      return true
    }
    return this.state.editableSiteIds.map(Number).includes(Number(siteId))
  }

  renderHeader(key: string): JSX.Element {
    if (this.state.location === 'overview' && key === 'company') {
      return <th className='d-none'>{key}</th>
    }
    return super.renderHeader(key)
  }
  renderRow(row: any, key: string, colIndex: number): JSX.Element {
    if (this.state.location === 'overview' && key === 'company') {
      return <td className='d-none'>{row[key]}</td>
    } else if (key === 'logo') {
      let imageUrl = row[key] ? row[key] : '/public/media/avatars/blank.png'
      return (
        <td key={colIndex}>
          <div className='symbol symbol-45px me-5'>
            <img src={imageUrl} alt={row['name']} />
          </div>
        </td>
      )
    } else if (key === 'is_active' || key === 'status') {
      let badgeClass = 'badge-success'
      switch (row[key]) {
        case 'Active':
          badgeClass = 'badge-success'
          break
        case 'Passive':
          badgeClass = 'badge-warning'
          break
        case 'Disabled':
          badgeClass = 'badge-warning'
          break
      }
      return (
        <td key={colIndex}>
          <div className={'badge ' + badgeClass}>{row[key]}</div>
        </td>
      )
    } else if (key === 'edit_actions') {
      const siteId = Number(row[key])
      const canEditRow = this.isRowEditable(siteId)
      return (
        <td key={colIndex}>
          <div className='d-flex justify-content-end flex-shrink-0'>
            <button
              type='button'
              disabled={!canEditRow}
              title={canEditRow ? 'Edit' : 'Editing is not available for this site'}
              onClick={() => {
                if (!canEditRow) {
                  return
                }
                this.props.editCallback(row[key], this.fetchData)
              }}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <span className='fa fa-edit'></span>
            </button>
            {this.state.canDelete ? (
              <button
                type='button'
                onClick={() => this.props.deleteCallback(row[key], this.fetchData)}
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
              >
                <span className='fa fa-trash'></span>
              </button>
            ) : null}
          </div>
        </td>
      )
    } else {
      return super.renderRow(row, key, colIndex)
    }
  }
}

export default CompanySitesTable as ComponentClass<CompanySitesProps>
